import { DataTable, ProgressBar, Text } from '@spark';

function distributionPercent(total, grandTotal) {
  if (!grandTotal) return '0.0%';
  return `${((total / grandTotal) * 100).toFixed(1)}%`;
}

function reviewPercent(validated, total) {
  if (!total) return 0;
  return Math.round((validated / total) * 100);
}

export default function BenchmarkDistributionNestedTable({ title, nameColumnHeader, rows }) {
  if (!rows?.length) return null;

  const grandTotal = rows.reduce((sum, row) => sum + (row.total ?? 0), 0);
  const columns = [
    { title: nameColumnHeader, dataIndex: 'label', key: 'label' },
    {
      title: 'Count',
      key: 'count',
      render: (_, record) => Number(record.total).toLocaleString(),
    },
    {
      title: 'Distribution %',
      key: 'distribution',
      render: (_, record) => distributionPercent(record.total, grandTotal),
    },
    {
      title: 'Reviewed',
      key: 'reviewed',
      render: (_, record) => `${record.validated}/${record.total}`,
    },
    {
      title: 'Review',
      key: 'review',
      render: (_, record) => (
        <ProgressBar value={reviewPercent(record.validated, record.total)} />
      ),
    },
  ];

  return (
    <div className="spark-datatable-expanded-section">
      {title ? (
        <Text variant="base-medium" color="primary" as="p">
          {title}
        </Text>
      ) : null}
      <DataTable
        className="spark-datatable-nested"
        columns={columns}
        dataSource={rows.map((row) => ({ ...row, _id: row.label }))}
        rowKey="_id"
        rowHeight={60}
        disableHoverBackground
        emptyText={null}
      />
    </div>
  );
}
